<template>
   <div class="modal-container has-background-primary">
            <div class="modal-header has-text-yell">
                <b>{{wordVariant ? 'Protected Word':'Trademark Protected'}}</b>
            </div>

            <div v-show="!showSuccess" class="modal-body">
                <div>
                    <b>The word or phrase you entered is available but protected{{wordVariant ? '' :' by trademarks'}}.  {{wordVariant ? 'If you would like to purchase this slink':'If you are the trademark owner and would like to claim this slink'}}, please contact <a style="color: white" href="mailto:legal@slink.com"><b>legal@slink.com</b></a>.</b>
                </div>
                <div class="has-text-centered">
                    <div class="has-text-centered is-size-3 top25 has-text-warning"><b>{{slink}}</b></div>
                </div>
                <div class="top25">
                    If you already obtained a claim validation code from us, please enter it here to claim your slink:<br>
                    <div class="has-text-centered">
                        <input type="text" class="input is-warning whiteInput top5 bottom5 has-text-dark" placeholder="enter code" v-model="code">
                        <div v-show="invalid" class="is-size-6" style="color: red">Invalid Code!</div><br>
                         <button id="sendButt" class="button is-warning is-small top20" @click="sendCode"><b>SUBMIT CODE</b></button>&nbsp; 
                        <button class="button top20 is-small" @click="cancel">CANCEL</button>
                    </div>
                </div>

            </div>

            <div v-show="showSuccess" class="has-text-centered">
                <div class="is-size-4 top60">Congratulations!</div>
                <div class="top20">The slink, <b>"{{slink}}"</b> has been added to your shopping cart. You may add more items to your shopping cart or proceed to checkout.</div>
                <div class="has-text-centered">
                <button class="button is-warning top20" @click="cancel">DONE</button>
            </div>
            </div>
            <br>

            
   </div>
</template>

<script>

export default{
    props: {slink: String, 
            wordVariant: {
                type: Boolean,
                default: false
            }
    },
    data: function(){
        return {
            code: '',
            showSuccess: false,
            invalid: false
        }
    },
    methods: {
        cancel: function(){
            this.$emit('close')
        },
        sendCode: function(){
            var self = this;
            if(this.code == ''){
                alert('return?')
                return
            }

            function w(d){
                az.addRemSpinner(false, 'id', 'sendButt')
              
                if(d.slink){
                   self.$root.successfulAddToCart(d, null, d.slink, null)
                   self.showSuccess = true
                } else {
                   self.invalid = true
                }
            }

            function n(){
                az.addRemSpinner(false, 'id', 'sendButt')
                self.invalid = true
            }

            az.addRemSpinner(true, 'id', 'sendButt')
            var cartID = az.getCookie('SlinkCartID');
            this.$root.apiClient.post('api/cart/claimcode', {val: this.slink + "|" + this.code}, w, n, null, {'cart-user-id': cartID})


        }
    }
}

</script>

<style scoped>
    .modal-container {
        max-width: 500px;
        min-height: 330px;
        border-radius: 15px;
        overflow: hidden;
        border-top: 6px solid #50abc7;
        padding: 15px
    }
    .whiteInput{
        background-color: whitesmoke !important;
        width: 150px;
    }
</style>


// WEBPACK FOOTER //
// src/components/ModalClaims.vue